// Régua única dos KPIs do dashboard: dado um valor + sentido + faixas, devolve o
// tom do card (3 bandas) e o status da meta para o selo do KpiCard.
// Centraliza a lógica de limiar→tom→status que estava duplicada inline em cada
// painel. Reusa faixaMin/faixaMax de comprasMetas (já testadas) — ver [[comprasMetas]].

import { faixaMin, faixaMax, type Faixa, type MetaSentido } from './comprasMetas'

export type KpiTone = 'default' | 'success' | 'warning' | 'danger' | 'info'

export interface KpiMeta {
  tone: KpiTone
  status: Faixa | null // null = sem dado → sem selo
  metaLabel: string // ex.: "≥ 8×", "≤ 7%"
}

export interface KpiBandsInput {
  value: number | null
  sentido: MetaSentido
  /** Limiar "na meta" (verde): atinge quando value ≥ verde (min) ou ≤ verde (max). */
  verde: number
  /** Limiar "atenção" (amarelo): entre amarelo e verde = atenção; pior que amarelo = fora. */
  amarelo: number
  /** Texto da meta. Se ausente, derivado de `verde` (+ `format`). */
  metaLabel?: string
  /** Formatador do metaLabel quando não passado (ex.: v => `${v}×`). */
  format?: (v: number) => string
}

const TONE_BY_FAIXA: Record<Faixa, KpiTone> = {
  verde: 'success',
  amarelo: 'warning',
  vermelho: 'danger',
}

export function kpiMeta(input: KpiBandsInput): KpiMeta {
  const { value, sentido, verde, amarelo, format } = input
  const fmt = format ?? ((v: number) => String(v))
  const metaLabel = input.metaLabel ?? `${sentido === 'min' ? '≥' : '≤'} ${fmt(verde)}`

  const status = sentido === 'min' ? faixaMin(value, verde, amarelo) : faixaMax(value, verde, amarelo)
  const tone: KpiTone = status == null ? 'default' : TONE_BY_FAIXA[status]
  return { tone, status, metaLabel }
}
